const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/email-notification-templates/reducers/email-notification-templates.reducer.js